import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

const useGoogleTagManager = () => {
  useEffect(() => {
    const gtmId = 'GTM-57RZX42N'

    TagManager.initialize({ gtmId })
  }, [])
}

export default useGoogleTagManager
